import {
  START_LOADING,
  STOP_LOADING,
  ERROR,
  SUCCESS,
  GET_CURRENCY_LIST,
  UPDATE_CURRENCY,
  ADDEDNEWCURRENCY,
  RESET,
  GET_ACTIVE_CURRENCY,
} from "../types/index.js";

const CurrencyReducer = (
  state = {
    IsError: false,
    isSuccess: false,
    isLoading: undefined,
  },
  action
) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case STOP_LOADING:
      return { ...state, isLoading: false };
    case GET_CURRENCY_LIST:
      return {
        ...state,
        currencyList: action.payload,
      };
    case UPDATE_CURRENCY:
      return {
        ...state,
        currencyList: action.payload,
      };
    case RESET:
      const data = state;
      data.currencyList = undefined;
      return data;
    case GET_ACTIVE_CURRENCY:
      return {
        ...state,
        currencyList: action.payload,
      };
    case ADDEDNEWCURRENCY:
      return {
        ...state,
      };
    case ERROR:
      return { ...state, IsError: true, isSuccess: false };
    case SUCCESS:
      return { ...state, IsError: false, isSuccess: true };
    default:
      return state;
  }
};
export default CurrencyReducer;
